const satelliteTrack = require('./toTrack');

const getErrorCode = (error, otpFlow) => {
  if (typeof error === 'string') {
    return error;
  }

  if (typeof error === 'object' && !error.code) {
    return JSON.stringify(error);
  }

  return otpFlow ? `${error.code}_OTPFLOW` : error.code;
};

function makeOmnitureTrack(errors, endPoint, statusCode, otpFlow) {
  const errorCodes = [];
  const errorMessages = [];

  for (const error of errors) {
    errorCodes.push(getErrorCode(error, otpFlow));
    errorMessages.push((error && error.message) || 'x');
  }
  try {
    if (typeof window !== 'undefined') {
      window.digitalData = {
        ...(window.digitalData || {}),
        ciamError: `${errorCodes.join(',')}|${errorMessages.join(',')}|${statusCode}|${endPoint}`,
      };
      satelliteTrack('ciam_error');
    }
  } catch {
    // Do Nothing
  }
}

function checkErrors(response, url, data, otpFlow) {
  let error;
  let statusCode = response.status;
  if (!response.ok) {
    error = response.statusText;
    statusCode = response.status;
  }
  let dataError = false;
  const errors = data && data.errors ? data.errors : [];
  if (errors.length) {
    dataError = true;
    makeOmnitureTrack(errors, url, statusCode, otpFlow);
  }

  if (error && !dataError) {
    makeOmnitureTrack([error], url, statusCode, otpFlow);
  }
}

module.exports = checkErrors;
